/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * Roamings section for the new campaign rateplan card
 *
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.39.0
 */

import map from 'lodash/map';
import { useSelector } from 'react-redux';

import { icons } from '@/main/assets';
import { ImgStyled } from '@components/common/Block/Img';
import { makeSelectTranslationPageProducts } from '@modules/internationalization/intSelectors';
import { RateplanTooltipIcon } from '@pages/PageProducts/components/ProductCards/RateplanTooltipIcon';
import {
    IProductCardTariffField,
    IProductCardTariffFieldRoaming,
} from '@pages/PageProducts/tariffsAndServicesProductTariffTypes';

import { checkValueUnlimited, getRoamingTooltip } from '../../utils/rateplanCardUtils';
import {
	VolumesStyled,
	VerticalDivStyled,
	VolumeTextStyled,
} from '../styled/RatePlanCard2025Styled';


export const RoamingsSection = (props: IProductCardTariffField<IProductCardTariffFieldRoaming[]>) => {
	const { value } = props;
    const { campaignTariffsCard: cardTranslation } = useSelector(makeSelectTranslationPageProducts());

    return (
        <VerticalDivStyled>
            {map(value, (item) => {
                const [isUnlimited, valueText] = checkValueUnlimited(item, cardTranslation);
                const tooltip = getRoamingTooltip(item, cardTranslation);
                return (
                    <VolumesStyled
                        $alignItems={'center'}
                        key={`${item.value}_${item.type}`}
                    >
                        {isUnlimited &&
                            <ImgStyled height="32px" src={icons.infinityIconThick} width="42px"/>
                        }
                        {!!valueText &&
                            <VolumeTextStyled variant="h2">
                                {valueText}
                            </VolumeTextStyled>
                        }
                        <RateplanTooltipIcon tooltip={tooltip}/>
                    </VolumesStyled>
                );
            })}
        </VerticalDivStyled>
    );
};
